
import { mapGetters } from 'vuex'
let frame = null
let SStimer = null

export default {
    /*
     modelCodeState
     999 授权客服上号
     998 为什么要授权客服上号提示
     997 发布账号重复 true
     996 发布账号重复 false
     995 稍后上号
     1 加载中
     2 验证码
     3 二维码
     4 游戏停服
     5 重新提交账号密码
    */
    props: {
        ruleForm: {
            type: Object,
            default: {}
        } // 商品提交信息
    },
    computed: {
        ...mapGetters({
            releaseDataObj: 'game/releaseDataObj',
            releaseGoodsBreadcrumb: 'game/releaseGoodsBreadcrumb'
        })
    },

    data () {
        return {
            thirdShotLoading: false, // 是否正在上号
            thirdShotType: '', // 截图类型
            empowerDialog: false, // 新发布弹窗状态
            modelCodeState: 0, // 显示步骤
            codeErrorStatus: false, // 二维码是否失效
            crateQrcode: null, // 二维码图片地址
            codeText: '刷新二维码', // 二维码结果提示文字
            isSend: false, // 禁用
            timer: null, // 进度条加载
            _codeTimer: null, // 获取验证码结果轮询
            _qrCodetimer: null, // 获取二维码扫码结果轮询
            percentage: 0, // 进度条
            goodsRequestId: null, // 自动截图id
            verifyCode: null, // 短信验证绑定
            verifyCodeTip: null, // 短信提示文案改用后端返回
            verifyCodeSms: null, // pz短信验证绑定
            errorCodeText: 0, // 短信验证错误提示
            pzLoading: false, // 熊猫lodding
            rules: {
                gameAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                gameSecret: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            accountFrom: {
                gameAccount: '',
                gameSecret: ''
            }, // 提交账密
            shopData: {}, // 商品信息
            saveState: false, // 返回给父级的保存状态
            sdkData: {
                user: null, // 账号
                pwd: null, // 密码
                gamePlatform: null, // 小算提供，平台
                gameId: null, // 小算提供，游戏id
                actionType: null, // 小算提供。操作类型 登录login 短信verifyCode
                // verifyCode: '', //短信，提交短信时使用
                channel: null // 小算提供，客户名称
            }, // 小算sdk
            sdkState: false,
            qrTypeText: 'QQ' // 扫码类型
        }
    },
    destroyed () {
        window.removeEventListener('message', this.getSdkCodeFn)
        window.removeEventListener('message', this.postSkdCodeFn)
    },
    methods: {
        getSdkCode (val) {
            frame = document?.querySelector('#iframe').contentWindow
            frame.postMessage(this.sdkData, '*')
            window.addEventListener('message', this.getSdkCodeFn)
        },
        getSdkCodeFn (e) {
            const data = e.data // 返回结果
            const origin = e.origin // 返回的域名
            console.log(data, 'sdk获取验证码')
            if (this.modelCodeState == false) {
                this.clearTime()
            }
            switch (data.actionType) {
            case 'VerifyCode':
                this.modelCodeState = 2
                clearInterval(this.timer)
                this.percentage = 0
                this.isSend = false
                this.sdkData.actionType = 'verifyCode'
                window.removeEventListener('message', this.getSdkCodeFn)
                break
            case 'data':
                window.removeEventListener('message', this.getSdkCodeFn)
                this.escalationResult(data.data)
                break
            default:
                break
            }
        },
        postSdkCode () {
            frame.postMessage(this.sdkData, '*')
            window.addEventListener('message', this.postSkdCodeFn)
        },
        postSkdCodeFn (e) {
            let _timer = null
            const _data = e.data // 返回结果
            console.log(_data, 'sdk提交验证码')
            if (this.modelCodeState == false) {
                this.clearTime()
            }
            window.removeEventListener('message', this.postSkdCodeFn)
            if (_data.data.actionType == 'VerifyCode') {
                const number = JSON.parse(_data.data)
                if (number == '2') {
                    this.clearTime()
                    this.getGoodsDtl()
                }
            } else if (_data?.data?.code == '3001') {
                this.escalationResult(_data.data)
                this.pzLoading = false
                clearInterval(_timer)
            } else {
                this.pzLoading = false
                this.clearTime()
                this.getGoodsDtl()
            }
            _timer = setInterval(() => {
                if (_data?.data?.actionType == 'VerifyCode') {
                    const number = JSON.parse(_data.data)
                    if (number == '2') {
                        this.clearTime()
                        this.getGoodsDtl()
                    }
                } else if (_data?.data?.code == '3001') {
                    this.escalationResult(_data.data)
                    this.pzLoading = false
                    clearInterval(_timer)
                } else {
                    this.pzLoading = false
                    this.clearTime()
                    this.getGoodsDtl()
                }
                window.removeEventListener('message', this.postSkdCodeFn)
            }, 10000)
        },
        // 向后端上报小算的结果
        escalationResult (val) {
            const data = {
                action: {
                    code: val.code,
                    goodsNo: this.shopData.action.goodsNo,
                    msg: val.message
                }
            }
            this.$api.sdkResultCommit(data).then(res => {
                this.clearTime()
                this.getGoodsDtl()
            })
        },
        // 手机号匹配正则加密
        phoneHide (phone) {
            const reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/ // 定义手机号正则表达式
            phone = phone.replace(reg, '$1****$2')
            return phone // 输出为131****1234
        },
        // 标题名称
        titleState (val) {
            let _title = ''
            switch (val) {
            case 999:
                _title = '授权客服上号'
                break
            case 998:
                _title = '为什么要授权客服上号'
                break
            case 997:
                _title = '发布账号重复'
                break
            case 996:
                _title = '发布账号重复'
                break
            case 995:
                _title = '稍后上号'
                break
            case 1:
                _title = '客服正在上号中'
                break
            case 2:
                _title = '需要验证码上号'
                break
            case 3:
                _title = '二维码扫码上号'
                break
            case 4:
                _title = '系统更新中'
                break
            case 5:
                _title = '重新提交账号密码'
                break
            }
            return _title
        },
        // 更新弹窗状态
        showType (state, val) {
            this.empowerDialog = state
            this.modelCodeState = val
        },
        // 关闭弹窗清空定时器
        clearTime () {
            clearInterval(SStimer)
            this.empowerDialog = false
            this.pzLoading = false
            clearInterval(this._codeTimer)
            clearInterval(this.timer)
            this.percentage = 0
            this.isSend = false
            clearInterval(this._qrCodetimer)
            this.$emit('onEmpowerDialogClose')
            window.removeEventListener('message', this.getSdkCodeFn)
            window.removeEventListener('message', this.postSkdCodeFn)
        },
        // 进度条加载
        countDownloading () {
            if (this.isSend) { return }
            this.modelCodeState = 1
            this.isSend = true
            this.percentage = 0
            this.timer = setInterval(() => {
                console.log(this.sdkData, console.log(SStimer))
                this.percentage++
                if (this.percentage >= 100) {
                    clearInterval(SStimer)
                    clearInterval(this.timer)
                    this.isSend = false
                    if (this.sdkData.actionType) {
                        this.getGoodsDtl()
                        this.clearTime()
                    }
                }
            }, 1300)
        },
        // 验证码轮询
        xiaosuanCommit () {
            const _data = {
                action: { goodsNo: this.shopData.action.goodsNo }
            }
            this.$api.thirdShotTaskStart(_data).then(res => {
                if (res.success) {
                    // 开启轮询
                    this.codePolling(60)
                    this.countDownloading()
                } else {
                    this.$message.error(res.info)
                    this.clearTime()
                }
            })
        },
        // 验证码重新提交
        codeSubmit () {
            const regex = /^[a-z0-9]+$/i
            if (!this.verifyCode) {
                this.$message.error('验证码不能为空')
                return
            }
            if (!regex.test(this.verifyCode)) {
                this.$message.error('请输入正确格式的验证码')
                return
            }
            if (this.sdkData.actionType == 'verifyCode') {
                // sdk
                this.pzLoading = true
                this.sdkData.verifyCode = this.verifyCode
                this.postSdkCode()
            } else {
                // 清空验证码错误提示
                if (this.errorCodeText >= 2) {
                    this.errorCodeText--
                }
                this.pzLoading = true
                const data = {
                    action: {
                        verifyCode: this.verifyCode,
                        goodsNo: this.shopData.action.goodsNo
                    }
                }
                this.$api.xiaosuanCodeCommit(data).then(res => {
                    if (res.success) {
                        // 开启轮询
                        this.codePolling(10)
                    } else {
                        this.pzLoading = false
                        this.$message.error(res.info)
                    }
                })
            }
        },
        // 验证码轮询-获取结果或获取验证码
        codePolling (number) {
            let _timeNum = number
            this._codeTimer = setInterval(() => {
                _timeNum--
                if (_timeNum <= 0) {
                    console.log('停止！')
                    this.modelCodeState = '0'
                    this.empowerDialog = false
                    this.pzLoading = false
                    clearInterval(this._codeTimer)
                    // 直接结果
                    this.getGoodsDtl()
                }
                const _statusData = {
                    goodsNo: this.shopData.action.goodsNo
                }
                this.$api.xiaosuanResult(_statusData).then(rest => {
                    if (rest.success) {
                        // 2  就弹验证码  6 就发布  -1 就是密码错误
                        switch (rest.data.code) {
                        case '2':
                            // 验证码输入
                            this.errorCodeText++
                            this.verifyCode = null
                            this.modelCodeState = 2
                            clearInterval(this._codeTimer)
                            clearInterval(this.timer)
                            this.pzLoading = false
                            this.percentage = 0
                            this.isSend = false
                            break
                        case '6':
                            // 发布
                            this.pzLoading = false
                            clearInterval(this._codeTimer)
                            clearInterval(this.timer)
                            this.empowerDialog = false
                            this.percentage = 0
                            this.isSend = false
                            // 直接结果
                            this.getGoodsDtl()
                            break
                        case '-1':
                            // 密码错误
                            this.empowerDialog = false
                            this.pzLoading = false
                            clearInterval(this._codeTimer)
                            clearInterval(this.timer)
                            this.modelCodeState = 5
                            this.$message.error('账号或密码错误，请重新填写')
                            this.percentage = 0
                            this.isSend = false
                            break
                        case '8':
                            // 三方截图失败，Redis中三方任务直接被删了，导致状态轮训无法获取数据
                            this.empowerDialog = false
                            this.pzLoading = false
                            clearInterval(this._codeTimer)
                            clearInterval(this.timer)
                            this.modelCodeState = '0'
                            this.$message.error('上号失败')
                            this.percentage = 0
                            this.getGoodsDtl()
                            this.isSend = false
                            break
                        }
                    } else {
                        clearInterval(this._codeTimer)
                        this.$message.error(rest.info)
                        this.getGoodsDtl()
                    }
                })
            }, 1000)
        },
        // 获取扫码类型
        setScanQrTypeText (res) {
            const typeMap = {
                1: 'QQ',
                2: '微信'
            }
            const qrType = typeMap[res.data.type]
            return res.data.qrCodePlatformName || qrType
        },
        // 二维码轮询
        onUserCenterGetQrCode () {
            this.crateQrcode = null
            clearInterval(this._qrCodetimer)
            const _data = {
                action: { goodsNo: this.shopData.action.goodsNo }
            }
            this.$api.thirdShotTaskStart(_data).then(res => {
                if (res.success) {
                    this.qrTypeText = this.setScanQrTypeText(res)
                    this.codeErrorStatus = true
                    this.codeText = '刷新二维码'
                    this.modelCodeState = 3
                    this._qrCodetimer = setInterval(() => {
                        this.$api.userCenterQrCodeStatus({ goodsNo: this.shopData.action.goodsNo }).then(rest => {
                            if (rest.success) {
                                this.crateQrcode = rest.data.qrCode
                                // 二维码状态码 200-等待扫码 400-扫码登录成功 401-二维码已失效请刷新 402-等待用户确认登录 403-用户取消确认 404-超时
                                switch (rest.data.code) {
                                case '400':
                                    this.codeText = '扫码登录成功'
                                    clearInterval(this._qrCodetimer)
                                    // 直接结果
                                    this.getGoodsDtl()
                                    break
                                case '401':
                                    this.codeText = '二维码已失效请刷新'
                                    this.codeErrorStatus = false
                                    clearInterval(this._qrCodetimer)
                                    break
                                case '402':
                                    this.codeText = '等待用户确认登录'
                                    break
                                }
                            } else {
                                clearInterval(this._qrCodetimer)
                                this.$message.error(rest.info)
                            }
                        })
                    }, 1000)
                } else {
                    this.$message.error(res.info)
                    this.clearTime()
                }
            })
        },
        // 重新提交账号密码
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const data = {
                        action: {
                            gameAccount: this.accountFrom.gameAccount,
                            gameSecret: this.accountFrom.gameSecret,
                            goodsNo: this.shopData.action.goodsNo
                        }
                    }
                    this.$api.thirdShotPasswordUpdate(data).then(res => {
                        if (res.success) {
                            this.sdkData.user = this.accountFrom.gameAccount
                            this.sdkData.pwd = this.accountFrom.gameSecret
                            this.getQRcodeOfCode()
                        } else {
                            this.modelCodeState = 996
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 发布商品前置校验
        userCenterGoodsCheck (p, state, number) {
            console.log(this.$route.path)
            this.shopData = p
            this.showType(state, number)
            if (number == 1) {
                const _time = setTimeout(() => {
                    this.getQRcodeOfCode()
                    clearInterval(_time)
                }, 1000)
            }
        },
        saveGoods () {
            this.$parent.saveData(this.shopData, true)
        },
        // 获取截图方式
        getQRcodeOfCode () {
            if (this.ruleForm.shotType == 'THIRD_SHOT') {
                this.countDownloading()
                this.$api.userCenterGetThridShotType(this.shopData).then(res => {
                    if (res.success) {
                        // 停服维护
                        const isServerClose = res.data.shutdown
                        if (isServerClose) {
                            this.showType(true, 4)
                            return
                        }
                        this.thirdShotType = res.data.thirdShotType
                        // 截图方式
                        switch (res.data.thirdShotType) {
                        case 'NONE':
                            console.log('老流程')
                            this.clearTime()
                            this.$parent.saveGoodsResetFields(this.shopData)
                            break
                        case 'XIAOSUAN_QR_CODE':
                            console.log('小算二维码')
                            this.onUserCenterGetQrCode()
                            break
                        case 'PANZHI_QR_CODE':
                            console.log('盼之二维码')
                            this.onUserCenterGetQrCode()
                            break
                        case 'XIAOSUAN_SMS_CODE':
                            console.log('小算验证码')
                            this.verifyCodeTip = res.data.verifyCodeTip
                            this.xiaosuanCommit()
                            break
                        case 'PANZHI_SMS_CODE':
                            console.log('盼之验证码')
                            break
                        case 'XIAOSUAN_SDK':
                            console.log('sdk')
                            this.sdkData.user = this.shopData.action.gameAccount // 小算提供，平台
                            this.sdkData.pwd = this.shopData.action.gameSecret // 小算提供，平台
                            this.sdkData.gamePlatform = res.data.thirdGamePlatform // 小算提供，平台
                            this.sdkData.gameId = res.data.thirdGameId // 小算提供，游戏id
                            this.sdkData.actionType = res.data.thirdActionType // 小算提供。操作类型 登录login 短信verifyCode
                            this.sdkData.channel = res.data.thirdChannel // 小算提供，客户名称
                            this.getSdkCode()
                            break
                        // 火影忍者定制脚本截图
                        case 'SCRIPT_SHOT':
                            this.sdkData.actionType = 'SCRIPT_SHOT'
                            this.getScriptShot()
                            break
                        }
                    } else {
                        this.$message.error(res.info)
                    }
                })
            } else {
                this.$parent.releaseConfirm(this.ruleForm)
            }
        },
        /**
		 * 火影忍者定制脚本截图
		 */
        async getScriptShot () {
            try {
                const releaseData = this.shopData.action
                const goodsNo = releaseData.goodsNo

                const data = {
                    action: {
                        goodsNo
                    }
                }
                const res = await this.$api.thirdTaskStartApi(data)
                if (!res.success) {
                    this.thirdShotLoading = false
                    clearInterval(this._qrCodetimer)
                    this.clearTime()
                    this.$message.error(res.info)
                    return
                }
                SStimer = setInterval(async () => {
                    try {
                        const res1 = await this.$api.thirdTaskStartStatusApi({ goodsNo })
                        if (!res1.success) {
                            this.$message.error(res1.info)
                            return
                        }
                        // 判断是否走验证码 SMS-验证码 QR_CODE-二维码
                        if (res1.data.authType === 'SMS') {
                            if (res1.data.status === 'AUTH_WAIT' || res1.data.status === 'AUTH_REFRESH') {
                                clearInterval(SStimer)
                                clearInterval(this.timer)
                                SStimer = null
                                this.percentage = 0
                                this.isSend = false
                                this.modelCodeState = 6 // 打开验证码弹窗
                            } else if (['AUTH_FAIL', 'AUTH_SUC'].includes(res1.data.status)) {
                                this.clearTime()
                                this.getGoodsDtl()
                            }
                        } else if (res1.data.authType === 'QR_CODE') {
                            if (res1.data.qrcode) {
                                clearInterval(SStimer)
                                clearInterval(this.timer)
                                this.thirdShotLoading = true
                                SStimer = null
                                this.codeErrorStatus = true
                                this.modelCodeState = 3 // 打开二维码弹窗
                                this.crateQrcode = res1.data.qrcode
                                this._qrCodetimer = null
                                this._qrCodetimer = setInterval(() => {
                                    this.$api.thirdTaskStartStatusApi({ goodsNo, cur_step: 2 }).then(rest => {
                                        if (rest.success) {
                                            this.crateQrcode = rest.data.qrcode
                                            this.qrTypeText = rest.data.qrCodePlatformName
                                            // 二维码状态码 200-等待扫码 400-扫码登录成功 401-二维码已失效请刷新 402-等待用户确认登录 403-用户取消确认 404-超时
                                            switch (rest.data.status) {
                                            case 'AUTH_SUC':
                                            case 'TIME_OUT':
                                                this.thirdShotLoading = false
                                                clearInterval(this._qrCodetimer)
                                                this.clearTime()
                                                this.getGoodsDtl()
                                                break
                                            case 'AUTH_WAIT':
                                            case 'AUTH_REFRESH':
                                                if (this.crateQrcode !== rest.data.qrcode) {
                                                    this.crateQrcode = rest.data.qrcode
                                                }
                                                this.thirdShotLoading = true
                                                break
                                            case 'LOADING':
                                                this.thirdShotLoading = true
                                                break
                                            default:
                                                this.thirdShotLoading = false
                                                clearInterval(this._qrCodetimer)
                                                this.clearTime()
                                                this.getGoodsDtl()
                                            }
                                        } else {
                                            clearInterval(this._qrCodetimer)
                                            this.$message.error(rest.info)
                                        }
                                    })
                                }, 2000)
                            }
                        } else if (res1.data.authType === 'NO_AUTH') {
                            clearInterval(SStimer)
                            clearInterval(this.timer)
                            this.thirdShotLoading = false
                            this.clearTime()
                            this.getGoodsDtl()
                        }
                    } catch (err) {
                        clearInterval(SStimer)
                        SStimer = null
                        this.clearTime()
                    }
                }, 2000)
            } catch (err) {
                clearInterval(SStimer)
                SStimer = null
                this.thirdShotLoading = false
                clearInterval(this._qrCodetimer)
                this.clearTime()
                this.getGoodsDtl()
            }
        },
        // 验证码重新提交
        codeSubmitSms () {
            const regex = /^[a-z0-9]+$/i
            if (!this.verifyCodeSms) {
                this.$message.error('验证码不能为空')
                return
            }
            if (!regex.test(this.verifyCodeSms)) {
                this.$message.error('请输入正确格式的验证码')
                return
            }
            // 清空验证码错误提示
            if (this.errorCodeText >= 2) {
                this.errorCodeText--
            }
            this.pzLoading = true
            const data = {
                action: {
                    smsCode: this.verifyCodeSms,
                    goodsNo: this.shopData.action.goodsNo
                }
            }
            this.$api.shotVerifyCodeAPI(data).then(res => {
                if (res.success) {
                    // 开启轮询
                    this.codePollingSms(10)
                } else {
                    this.pzLoading = false
                    this.$message.error(res.info)
                }
            })
        },
        // 验证码轮询-获取结果或获取验证码
        codePollingSms (number) {
            let _timeNum = number
            this._codeTimer = setInterval(() => {
                _timeNum--
                if (_timeNum <= 0) {
                    console.log('停止！')
                    this.modelCodeState = '0'
                    this.empowerDialog = false
                    this.pzLoading = false
                    clearInterval(this._codeTimer)
                    // 直接结果
                    this.getGoodsDtl()
                }
                const _statusData = {
                    goodsNo: this.shopData.action.goodsNo
                }
                this.$api.thirdTaskStartStatusApi(_statusData).then(rest => {
                    if (rest.success) {
                        // "LOADING:加載中 AUTH_WAIT:等待认证 AUTH_REFRESH:重新认证 AUTH_SUC:认证成功"
                        switch (rest.data.status) {
                        case 'AUTH_SUC':
                            // 发布
                            this.pzLoading = false
                            clearInterval(this._codeTimer)
                            clearInterval(this.timer)
                            this.empowerDialog = false
                            this.percentage = 0
                            this.isSend = false
                            // 直接结果
                            this.getGoodsDtl()
                            break
                        case 'AUTH_REFRESH':
                            // 重新验证
                            this.empowerDialog = false
                            this.pzLoading = false
                            clearInterval(this._codeTimer)
                            clearInterval(this.timer)
                            this.modelCodeState = 6
                            this.$message.error('验证码错误，请重新填写')
                            this.percentage = 0
                            this.isSend = false
                            break
                        }
                    } else {
                        clearInterval(this._codeTimer)
                        this.$message.error(rest.info)
                        this.getGoodsDtl()
                    }
                })
            }, 1000)
        },
        // 稍后上号
        later (state) {
            this.showType(true, 995)
            this.saveState = state
        },
        // 稍后上号
        gotoGoodsDtl () {
            this.clearTime()
            if (this.saveState) {
                this.$parent.saveData(this.shopData, false)
            } else {
                this.$router.push({
                    path: '/account/sellerDetails',
                    query: {
                        status: 'WAIT_PUBLISH',
                        goodsNo: this.shopData.action.goodsNo,
                        orderStatus: '待发布',
                        gameId: this.shopData.action.gameId,
                        goodsCatalogueId: this.shopData.action.goodsCatalogueId
                    }
                })
            }
        },
        // 发布成功
        getGoodsDtl () {
            this.empowerDialog = false
            this.$router.push({
                path: '/account/sellerDetails',
                query: {
                    status: 'WAIT_PUBLISH',
                    goodsNo: this.shopData.action.goodsNo,
                    orderStatus: '待发布',
                    gameId: this.shopData.action.gameId,
                    goodsCatalogueId: this.shopData.action.goodsCatalogueId,
                    reload: true
                }
            })
        },
        // 稍后上号
        gotoGoodsList () {
            this.clearTime()
            this.$router.push({
                path: '/account/sellerList',
                query: { staus: 'WAIT_PUBLISH' }
            })
        }
    }
}
